/** @format */

import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WINDOW } from '@shared/data-access/services';
import { EvergreenTemplateData } from '../google-ad-manager/google-ad-manager.interface';

@Component({
	selector: 'shared-components-evergreen-template',
	templateUrl: './evergreen-template.component.html',
	styleUrl: './evergreen-template.component.scss',
	imports: [CommonModule]
})
export class EvergreenTemplateComponent {
	templateData = input<EvergreenTemplateData | null>(null);
	isNarrowTemplate = input<boolean>(false);

	private readonly window = inject(WINDOW);

	onClick(): void {
		const data = this.templateData();
		if (data?.CTA_URL) {
			const target = data.CTA_TAB_BEHAVIOR || '_blank';
			this.window.open(data.CTA_URL, target);
		}
	}
}
